document.addEventListener('DOMContentLoaded', function() {
	const transparentWhitePages = [
    // main
    '/',
    '/en',
    '/zh',
    '/en/',
    '/zh/',
    '/zh-hant',
    '/zh-hant/',
    '/zh-hans',
    '/zh-hans/',

    '/pages/ricambi',
    '/en/pages/ricambi',
    '/zh-hant/pages/ricambi',
    '/zh-hans/pages/ricambi',

    '/pages/contact',
    '/en/pages/contact',
    '/zh-hant/pages/contact',
    '/zh-hans/pages/contact',

    // Amika
    '/products/amika',
    '/en/products/amika',
    '/zh/products/amika',
    '/zh-hans/products/amika',
    '/zh-hant/products/amika',

    // Magnetika
    '/products/magnetika',
    '/en/products/magnetika',
    '/zh/products/magnetika',
    '/zh-hans/products/magnetika',
    '/zh-hant/products/magnetika',

    // Amika Berenice
    '/products/amika-berenice',
    '/en/products/amika-berenice',
    '/zh/products/amika-berenice',
    '/zh-hans/products/amika-berenice',
    '/zh-hant/products/amika-berenice',

    // Amika Ottavia
    '/products/amika-ottavia',
    '/en/products/amika-ottavia',
    '/zh/products/amika-ottavia',
    '/zh-hans/products/amika-ottavia',
    '/zh-hant/products/amika-ottavia',

    // Amika Lucrezia
    '/products/amika-lucrezia',
    '/en/products/amika-lucrezia',
    '/zh/products/amika-lucrezia',
    '/zh-hans/products/amika-lucrezia',
    '/zh-hant/products/amika-lucrezia',

    // Amika Febe
    '/products/amika-febe',
    '/en/products/amika-febe',
    '/zh/products/amika-febe',
    '/zh-hans/products/amika-febe',
    '/zh-hant/products/amika-febe',

    // Amika Augusta
    '/products/amika-augusta',
    '/en/products/amika-augusta',
    '/zh/products/amika-augusta',
    '/zh-hans/products/amika-augusta',
    '/zh-hant/products/amika-augusta',

    // Amika Aurelia
    '/products/amika-aurelia',
    '/en/products/amika-aurelia',
    '/zh/products/amika-aurelia',
    '/zh-hans/products/amika-aurelia',
    '/zh-hant/products/amika-aurelia',

    // Rumba
    '/products/rumba',
    '/en/products/rumba',
    '/zh/products/rumba',
    '/zh-hans/products/rumba',
    '/zh-hant/products/rumba',

    // Orze
    '/products/orze',
    '/en/products/orze',
    '/zh/products/orze',
    '/zh-hans/products/orze',
    '/zh-hant/products/orze',

    // Orzetek
    '/products/orzetek',
    '/en/products/orzetek',
    '/zh/products/orzetek',
    '/zh-hans/products/orzetek',
    '/zh-hant/products/orzetek'
];

    // Прозрачный хедер с ЧЁРНЫМИ буквами
    const transparentDarkPages = [
        
    ];
    
    // ============================================================

    const header = document.getElementById('CustomHeader');
    const mainContent = document.querySelector('main');
    const headerWrapper = document.querySelector('.header-wrapper');

    if (!header || !headerWrapper || !mainContent) {
        console.error("Не найдены основные элементы: header, header-wrapper или main.");
        return;
    }

    const headerHeight = header.offsetHeight;
    const currentPagePath = window.location.pathname;
    const isHomepage = currentPagePath === '/';

    let lastScrollTop = 0;
    const scrollThreshold = 100;
    const delta = 5; // Минимальное изменение скролла для срабатывани

    window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        
        // Игнорируем мелкие изменения
        if (Math.abs(lastScrollTop - currentScroll) <= delta) return;
        
        if (currentScroll < scrollThreshold) {
            header.style.transform = 'translateY(0)';
        } else if (currentScroll > lastScrollTop) {
            // Скролл вниз
            header.style.transform = 'translateY(-100%)';
        } else {
            // Скролл вверх
            header.style.transform = 'translateY(0)';
        }
        
        header.style.transition = 'transform 0.3s ease-in-out';
        lastScrollTop = currentScroll;
    }, false);


    // --- ЛОГИКА ОТОБРАЖЕНИЯ ХЕДЕРА ---
    if (transparentWhitePages.includes(currentPagePath)) {
        // Прозрачный с белыми буквами
        headerWrapper.classList.add('header-style-transparent');
        headerWrapper.classList.remove('header-style-transparent-dark');
        mainContent.style.paddingTop = '0px';
    } else if (transparentDarkPages.includes(currentPagePath)) {
        // Прозрачный с чёрными буквами
        headerWrapper.classList.add('header-style-transparent-dark');
        headerWrapper.classList.remove('header-style-transparent');
        mainContent.style.paddingTop = '0px';
    } else {
        // По умолчанию: белый фон с чёрными буквами
        headerWrapper.classList.remove('header-style-transparent');
        headerWrapper.classList.remove('header-style-transparent-dark');
        mainContent.style.paddingTop = headerHeight + 'px';
    }

    // --- АНИМАЦИИ GSAP (Только если GSAP загружен) ---
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && typeof SplitType !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
        const heroSection = document.getElementById('CustomHeroSection');

        // === ФУНКЦИИ СМЕНЫ ХЕДЕРА ===
        function setHeaderTransparentStyle() {
            gsap.to(header, { backgroundColor: 'transparent', borderBottomColor: 'transparent', duration: 0.4 });
            gsap.to('.custom-header__icon:not(.custom-header__language-icon)', { color: 'white', duration: 0.4 });
            gsap.to('.custom-header__nav a', { color: 'white', duration: 0.4, overwrite: 'auto' });
            gsap.to('.logo--light', { opacity: 1, duration: 0.4 });
            gsap.to('.logo--dark, .logo-text--dark', { opacity: 0, duration: 0.4 });
        }

        function setHeaderDefaultStyle() {
            gsap.to(header, { backgroundColor: 'white', borderBottomColor: '#e0e0e0', duration: 0.4 });
            gsap.to('.custom-header__icon:not(.custom-header__language-icon)', { color: 'black', duration: 0.4 });
            gsap.to('.custom-header__nav a', { color: 'black', duration: 0.4, overwrite: 'auto' });
            gsap.to('.logo--light', { opacity: 0, duration: 0.4 });
            gsap.to('.logo--dark, .logo-text--dark', { opacity: 1, duration: 0.4 });
        }
        // === КОНЕЦ ФУНКЦИЙ СМЕНЫ ХЕДЕРА ===

        // --- Анимации ТОЛЬКО для ГЛАВНОЙ страницы ---
        if (heroSection) {

                    /* =================================================================== */
                    /* ===== АНИМАЦИЯ ТЕКСТА (ПОБУКВЕННО) ================================ */
                    /* =================================================================== */

                    const heroSection = document.querySelector("#CustomHeroSection");

                    if (heroSection) {
            const split = new SplitType('.hero-heading > span', { types: 'chars' });
            const chars = split.chars;

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: heroSection,
                    pin: true,
                    scrub: 1,
                    start: "top top",
                    end: "+=100%",
                }
            });

            // 1. Ставим метку "start", чтобы синхронизировать обе анимации
            tl.addLabel("start");

            // 2. Анимация БУКВ (Запускаем в момент "start")
            tl.to(chars, {
                opacity: 0,
                yPercent: -100,
                filter: "blur(10px)",
                stagger: {
                    amount: 0.7, 
                    from: "random"
                },
                duration: 1 // Явное время для букв (в контексте scrub это пропорция)
            }, "start"); // <--- ВАЖНО: Привязываем к метке "start"

            // 3. Анимация ФОНА (Запускаем в "start" ПЛЮС 0.15 сек)
            // tl.to('.hero-heading', {
            //     backdropFilter: "blur(0px)", 
            //     webkitBackdropFilter: "blur(0px)",
            //     duration: 1, // Длится столько же, сколько анимация букв (или поставьте меньше, чтобы исчез быстрее)
            // }, "start+=0.15"); // <--- ВАЖНО: Начинаем через 0.15 сек после старта букв
        }

            /* =================================================================== */
            /* ================= КОНЕЦ БЛОКА АНИМАЦИИ ТЕКСТА ===================== */
            /* =================================================================== */

            // Анимация смены цвета при скролле
            gsap.to(header, {
                scrollTrigger: {
                    trigger: heroSection,
                    start: "bottom top",
                    scrub: 1,

                    onEnter: () => {
                        setHeaderDefaultStyle();
                        headerWrapper.classList.remove('header-style-transparent');
                    },
                    onLeaveBack: () => {
                        setHeaderTransparentStyle();
                        headerWrapper.classList.add('header-style-transparent');
                    }
                }
            });

            // Анимация скрытия/появления хедера
            const hideHeaderAnim = gsap.from(header, {
                yPercent: -100,
                paused: true,
                duration: 0.3,
                ease: 'power1.inOut'
            }).progress(1);

            ScrollTrigger.create({
                start: "top top",
                end: "max",
                onUpdate: (self) => {
                    if (self.direction === 1 && self.scroll() > heroSection.offsetHeight) {
                        hideHeaderAnim.reverse();
                    } else {
                        hideHeaderAnim.play();
                    }
                }
            });
        }

        // ============================================================
        // НАСТРОЙКА НОВОЙ СЕКЦИИ НА ГЛАВНОЙ (GSAP)
        // ============================================================
        
        // 1. Укажите здесь ID или Класс вашей новой секции
        // const specialSection = document.querySelector('#webgl-canvas-1'); 

        // if (specialSection) {
            
        //     // Функция для стиля этой конкретной секции
        //     function setSpecialSectionHeaderStyle() {
        //         // Фон прозрачный
        //         gsap.to(header, { backgroundColor: 'transparent', borderBottomColor: 'transparent', duration: 0.4 });
                
        //         // --- ВЫБОР ЦВЕТА ТЕКСТА ---
                
        //         // ВАРИАНТ А: ЧЕРНЫЕ буквы (если фон секции светлый)
        //         gsap.to('.custom-header__icon:not(.custom-header__language-icon)', { color: 'black', duration: 0.4 });
        //         gsap.to('.custom-header__nav a', { color: 'black', duration: 0.4, overwrite: 'auto' });
        //         gsap.to('.logo--light', { opacity: 0, duration: 0.4 });
        //         gsap.to('.logo--dark, .logo-text--dark', { opacity: 1, duration: 0.4 });
                
        //         /* // ВАРИАНТ Б: БЕЛЫЕ буквы (если фон секции темный) - Раскомментируйте это и закомментируйте Вариант А
        //         gsap.to('.custom-header__icon:not(.custom-header__language-icon)', { color: 'white', duration: 0.4 });
        //         gsap.to('.custom-header__nav a', { color: 'white', duration: 0.4, overwrite: 'auto' });
        //         gsap.to('.logo--light', { opacity: 1, duration: 0.4 });
        //         gsap.to('.logo--dark, .logo-text--dark', { opacity: 0, duration: 0.4 });
        //         */
        //     }

        //     // Создаем триггер скролла
        //     ScrollTrigger.create({
        //         trigger: specialSection,
        //         start: "top top",    // Когда верх секции касается верха экрана
        //         end: "bottom top",   // Когда низ секции касается верха экрана
        //         scrub: false,        // false = анимация играет сразу, true = привязана к движению мыши
                
        //         // Когда заходим в секцию (сверху или снизу)
        //         onEnter: () => {
        //             setSpecialSectionHeaderStyle();
        //             headerWrapper.classList.add('header-style-transparent-dark'); // Добавляем класс для ховеров
        //         },
        //         onEnterBack: () => {
        //             setSpecialSectionHeaderStyle();
        //             headerWrapper.classList.add('header-style-transparent-dark');
        //         },
                
        //         // Когда уходим из секции (вверх или вниз) -> возвращаем белый фон
        //         onLeave: () => {
        //             setHeaderDefaultStyle();
        //             headerWrapper.classList.remove('header-style-transparent-dark');
        //         },
        //         onLeaveBack: () => {
        //             setHeaderDefaultStyle();
        //             headerWrapper.classList.remove('header-style-transparent-dark');
        //         }
        //     });
        // }

        /* =================================================================== */
        /* ===== АНИМАЦИЯ МЕНЮ (Подъем + УМНАЯ Смена цвета) ============ */
        /* =================================================================== */

        const menuLinks = document.querySelectorAll('.custom-header__nav a');

        if (menuLinks.length > 0) {
            menuLinks.forEach(link => {

                const hoverTimeline = gsap.timeline({ paused: true });
                hoverTimeline.to(link, {
                    y: -6,
                    duration: 0.3,
                    ease: 'power1.out'
                });

                link.addEventListener('mouseenter', () => {
                    hoverTimeline.play();
                    const isTransparent = headerWrapper.classList.contains('header-style-transparent');
                    
                    let hoverColor;
                    if (isTransparent) {
                        hoverColor = 'rgb(223, 223, 223)'; // Светло-серый для белого текста
                    } else {
                        hoverColor = 'rgb(28, 28, 28)'; // Тёмно-серый для чёрного текста
                    }
                    
                    gsap.to(link, {
                        color: hoverColor,
                        duration: 0.3,
                        ease: 'power1.out',
                        overwrite: 'auto'
                    });
                });

                link.addEventListener('mouseleave', () => {
                    hoverTimeline.reverse();
                    const isTransparent = headerWrapper.classList.contains('header-style-transparent');
                    
                    const originalColor = (isTransparent) ? 'rgb(255, 255, 255)' : 'rgb(0, 0, 0)';
                    
                    gsap.to(link, {
                        color: originalColor,
                        duration: 0.3,
                        ease: 'power1.out',
                        overwrite: 'auto'
                    });
                });

                /* =================================================================== */
                /* ===== АНИМАЦИЯ "Испарения" при КЛИКЕ ============= */
                /* =================================================================== */

                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    const href = link.href;

                    hoverTimeline.reverse();

                    const split = new SplitType(link, { types: 'chars' });

                    gsap.to(split.chars, {
                        opacity: 0,
                        yPercent: -120,
                        filter: 'blur(5px)',
                        scale: 0.8,
                        duration: 0.4,
                        ease: 'power1.in',
                        stagger: {
                            amount: 0.4,
                            from: "random"
                        },

                        onComplete: () => {
                            window.location.href = href;

                            setTimeout(() => {
                                split.revert();
                            }, 500);
                        }
                    });
                });
            });
        }

        /* ===== АНИМАЦИЯ МОБИЛЬНОГО БУРГЕР-МЕНЮ ===== */

        const burgerIcon = document.querySelector('.burger-menu');
        const mobileNav = document.querySelector('.mobile-nav-menu');
        const mobileNavLinks = document.querySelectorAll('.mobile-nav-menu a');

        if (burgerIcon && mobileNav) {
            
            gsap.set(mobileNav, { autoAlpha: 0 });

            const menuToggleTimeline = gsap.timeline({ 
                paused: true, 
                reversed: true,
                onStart: () => header.classList.add('is-open'),
                onReverseComplete: () => header.classList.remove('is-open')
            });

            menuToggleTimeline
                .to(burgerIcon.querySelector('.line1'), { 
                    duration: 0.3, 
                    rotation: 45, 
                    y: 9.25,
                    ease: "power2.inOut" 
                }, "start")
                .to(burgerIcon.querySelector('.line2'), { 
                    duration: 0.3, 
                    opacity: 0, 
                    ease: "power2.inOut" 
                }, "start")
                .to(burgerIcon.querySelector('.line3'), { 
                    duration: 0.3, 
                    rotation: -45, 
                    y: -9.25, 
                    ease: "power2.inOut" 
                }, "start")
                .to(mobileNav, { 
                    duration: 0.4, 
                    autoAlpha: 1,
                    ease: "power2.out" 
                }, "-=0.2");

            burgerIcon.addEventListener('click', () => {
                menuToggleTimeline.reversed() ? menuToggleTimeline.play() : menuToggleTimeline.reverse();
            });

            mobileNavLinks.forEach(link => {
                link.addEventListener('click', () => {
                    menuToggleTimeline.reverse();
                });
            });
        }

        // Анимация иконок (SVG) при наведении
        const icons = document.querySelectorAll('.custom-header__icon');
        if (icons.length > 0) {
            icons.forEach(iconLink => {
                const svg = iconLink.querySelector('svg');
                if (!svg) return;

                gsap.set(svg, { transformOrigin: '50% 50%' });
                const hoverTimeline = gsap.timeline({ paused: true });

                hoverTimeline.to(svg, {
                    scale: 1.25,
                    rotation: -10,
                    ease: 'elastic.out(1, 0.5)',
                    duration: 0.6
                });

                iconLink.addEventListener('mouseenter', () => {
                    hoverTimeline.play();
                });
                iconLink.addEventListener('mouseleave', () => {
                    hoverTimeline.reverse();
                });
            });
        }

        // Анимация логотипа при наведении
        const logoLink = document.querySelector('.custom-header__logo a');
        if (logoLink) {
            gsap.set(logoLink, { transformOrigin: '50% 50%' });
            const logoHoverTimeline = gsap.timeline({ paused: true });

            logoHoverTimeline.to(logoLink, {
                y: -6,
                ease: 'power2.out',
                duration: 0.3
            });

            logoLink.addEventListener('mouseenter', () => {
                logoHoverTimeline.play();
            });
            logoLink.addEventListener('mouseleave', () => {
                logoHoverTimeline.reverse();
            });
        }

    }
});
